{{#each this}}
  <li class='reviews__item'>
    <img
      loading='lazy'
      src={{photo}}
      alt={{author}}
      class='reviews__photo'
      width='100'
      height='100'
    />
    <blockquote class='reviews__quote'>
      <p class='reviews__text'>
        “{{text}}”
      </p>
      <figcaption class='reviews__author'>{{author}}
        <time datetime='2001-05-15' class='reviews__date'>{{date}}</time>
      </figcaption>
    </blockquote>

  </li>
{{/each}}